import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';

@Component({
  selector: 'app-my-target-report',
  templateUrl: './my-target-report.component.html',
  styleUrls: ['./my-target-report.component.css']
})
export class MyTargetReportComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  selectedPartner;
  partnerList;
  selectedClient;
  clientList;
  userId;
  isClientSelected: boolean;
  reportList;

  constructor(private masterDataService:MasterDataService,private organizationSetupService:OrganizationSetupService,
    private humanResourceService:HumanResourceService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = '';
    this.selectedPartner='';
    this.userId=localStorage.getItem('id');
    this.loadFinancialDetails();
  }

  loadFinancialDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onFinancialYearSlected(){
    this.humanResourceService.getClientsByFY(this.userId, this.selectedFinancialYear.id).subscribe((resp:any)=>{
      console.log('client list',resp);
      this.clientList =resp;
    })
  }

  selectAllClient(select: NgModel, values) {
    this.selectAll(select, values, this.isClientSelected);
    this.isClientSelected = !this.isClientSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  setRowSpanForBranchDetails(clientDetail) {
    var count = 0;
    clientDetail.assignments.map((res1: any) => {
      res1.actualDays.map((res2: any) => {
        count++;
      });
    });
    return count;
  }

  onViewReport(){
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedClient == null ||
      this.selectedClient.length == 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('','Please choose all the values');
      return;
    }
    var clientId = this.selectedClient.map(({ id }) => id);
    this.masterDataService.getMyTargetReportDetails(this.userId,this.selectedFinancialYear.id,clientId).subscribe((resp:any)=>{
    console.log('target report details',this.reportList);
    this.reportList=resp;
    })
  }

  
  onExportToExcelReport(){}
}
